import React from 'react';
import { Coins, Gem, Wallet } from 'lucide-react';
import { inr } from '@/lib/tagPricing';
import { fineGold } from '@/lib/tagSales';

// Premium tiles: Gold 999 grams @ rate, other materials & misc value, total value.
export function GoldTiles({ lines, compact, testid }) {
  const f = fineGold(lines);
  const tiles = [
    { icon: Coins, label: 'Gold 999', value: `${f.fg.toFixed(3)} g`, sub: `@ Rs. ${inr(f.rate)}/g${f.mixed ? ' avg' : ''} · Rs. ${inr(f.gold)}`, tone: 'from-amber-500/15 to-amber-500/0 border-amber-600/30 text-amber-800 dark:text-amber-300', id: 'gold' },
    { icon: Gem, label: compact ? 'Other & misc' : 'Other materials & misc', value: `Rs. ${inr(f.other)}`, sub: 'Stones, pearls, labour & charges', tone: 'from-sky-500/10 to-sky-500/0 border-sky-600/25 text-sky-800 dark:text-sky-300', id: 'other' },
    { icon: Wallet, label: 'Total value', value: `Rs. ${inr(f.total)}`, sub: `${lines.length} piece${lines.length === 1 ? '' : 's'}`, tone: 'from-emerald-600/15 to-emerald-600/0 border-emerald-700/30 text-emerald-800 dark:text-emerald-300', id: 'total' },
  ];
  return (
    <div className={`grid gap-2 ${compact ? 'grid-cols-3' : 'grid-cols-1 sm:grid-cols-3 sm:gap-3'}`} data-testid={testid}>
      {tiles.map(({ icon: I, label, value, sub, tone, id }) => (
        <div key={id} className={`rounded-2xl border bg-gradient-to-br ${tone} ${compact ? 'px-2.5 py-2' : 'px-4 py-3'}`} data-testid={`${testid}-${id}`}>
          <div className="flex items-center gap-1.5 whitespace-nowrap text-[length:calc(var(--fs,1)*0.625rem)] font-semibold uppercase tracking-[0.12em] opacity-90"><I size={compact ? 11 : 13} /> {label}</div>
          <div className={`font-mono font-bold tabular-nums text-foreground ${compact ? 'text-[length:calc(var(--fs,1)*0.8125rem)]' : 'mt-0.5 text-xl'}`}>{value}</div>
          {!compact || id === 'gold' ? <div className={`text-[length:calc(var(--fs,1)*0.65625rem)] text-muted-foreground ${compact ? 'leading-tight' : 'truncate'}`}>{sub}</div> : null}
        </div>
      ))}
    </div>
  );
}
